<template>
  <div>
    <table id="head">
      <tr>
        <th>Miejsce wystawienia</th>
        <td>:</td>
        <td>
          <editable :id="`place-${_uid}`" :value="invoice.place" @change="invoice.place = $event"></editable>
        </td>
      </tr>
      <tr>
        <th>Data wystawienia</th>
        <td>:</td>
        <td>
          <editable date :id="`date-${_uid}`" :value="invoice.date" @change="invoice.date = $event"></editable>
        </td>
      </tr>
      <tr>
        <th>Data wykonania usługi</th>
        <td>:</td>
        <td>
          <editable date :id="`deliveryDate-${_uid}`" :value="invoice.deliveryDate" @change="invoice.deliveryDate = $event"></editable>
        </td>
      </tr>
    </table>
    <section id="seller">
      <h3>Sprzedawca</h3>
      <p>
        <editable multiline :id="`seller-${_uid}`" :value="invoice.seller" @change="invoice.seller = $event"></editable>
      </p>
    </section>

    <section id="buyer">
      <h3>Nabywca</h3>
      <p>
        <editable multiline :id="`buyer-${_uid}`" :value="invoice.buyer" @change="invoice.buyer = $event"></editable>
      </p>
    </section>

    <h1>
      <editable :id="`title-${_uid}`" :value="invoice.title" @change="invoice.title = $event"></editable>
    </h1>
    <h2>
      <editable :id="`id-${_uid}`" :value="invoice.id" @change="invoice.id = $event"></editable>
    </h2>

    <table id="products">
      <thead>
        <tr>
          <td><span>Lp</span></td>
          <td><span>Nazwa usługi</span></td>
          <td colspan="2"><span>Ilość<br>J.m.</span></td>
          <td class="number"><span>Cena netto<small>[PLN]</small></span></td>
          <td class="number"><span>VAT<small>[%]</small></span></td>
          <td class="number"><span>Wartość netto<small>[PLN]</small></span></td>
          <td class="number"><span>Wartość VAT<small>[PLN]<small></span></td>
          <td class="number"><span>Wartość brutto<small>[PLN]</small></span></td>
        </tr>
      </thead>
      <products
        id="product-list"
        :products="invoice.products"
        @remove="removeProduct"
        @change="changeProduct"
      ></products>
      <products-summary id="summary" :products="invoice.products" @new="newProduct"></products-summary>
      <products-total id="total" :products="invoice.products"></products-total>
    </table>
    <table id="foot">
      <tbody>
        <tr>
          <th>Do zapłaty</th>
          <td></td>
          <td>{{ money(total) }} <small>PLN</small></td>
        </tr>
        <tr>
          <th>Termin płatności</th>
          <td></td>
          <td>
            <editable date :id="`paymentDate-${_uid}`" :value="invoice.paymentDate" @change="invoice.paymentDate = $event"></editable>
          </td>
        </tr>
        <tr>
          <th>Forma płatności</th>
          <td></td>
          <td>
            <editable :id="`paymentType-${_uid}`" :value="invoice.paymentType" @change="invoice.paymentType = $event"></editable>
          </td>
        </tr>
        <tr v-for="(f, idx) in invoice.footer" :key="f.id" :class="{empty: f.name === ''}">
          <th><button @click="removeFooter(idx)">Usuń</button><editable :id="`footer-name-${idx}-${_uid}`" :value="f.name" @change="f.name = $event"></editable></th>
          <td></td>
          <td><editable :id="`footer-value-${idx}-${_uid}`" :value="f.value" @change="f.value = $event"></editable></td>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td colspan="3"><button @click="addFooter()">Dodaj</button></td>
        </tr>
      </tbody>
    </table>
    <section class="signature">
      <p>
        <editable :id="`buyerSignature-${_uid}`" :value="invoice.buyerSignature" @change="invoice.buyerSignature = $event"></editable>
      </p>
      <small>Imię, nazwisko i podpis osoby uprawnionej do odbioru dokumentu</small>
    </section>
    <section class="signature">
      <p>
        <editable :id="`sellerSignature-${_uid}`" :value="invoice.sellerSignature" @change="invoice.sellerSignature = $event"></editable>
      </p>
      <small>Podpis osoby uprawnionej do wystawienia dokumentu</small>
    </section>
  </div>
</template>

<script>
import accounting from 'accounting'
import Editable from 'components/Editable'
import Products from 'components/Products/InvoiceList'
import ProductsSummary from 'components/Products/InvoiceSummary'
import ProductsTotal from 'components/Products/InvoiceTotal'
import moment from 'moment'

const emptyProduct = {
  name: '',
  quantity: 1,
  quantityType: 'usł.',
  priceNetto: 0,
  vat: 23,
  nettoValue: 0,
  vatValue: 0,
  bruttoValue: 0
}

export default {
  data () {
    return {
      invoice: {
        title: 'Faktura VAT',
        id: `${moment().format('YYYY/MMDD')}01`,
        place: '',
        date: moment().format('DD.MM.YYYY'),
        deliveryDate: moment().format('DD.MM.YYYY'),
        seller: '',
        buyer: '',
        paymentDate: moment().add(14, 'days').format('DD.MM.YYYY'),
        paymentType: 'Przelew',
        sellerSignature: '',
        buyerSignature: '',
        products: [
          Object.assign({}, emptyProduct)
        ],
        footer: [
          {
            id: Math.random(),
            name: 'Numer konta',
            value: 'xx xxxx xxxx xxxx xxxx xxxx xxxx (bank)'
          }
        ]
      }
    }
  },
  computed: {
    total () {
      let total = 0
      this.invoice.products.forEach(s => {
        total += s.bruttoValue
      })
      return total
    }
  },
  methods: {
    money (value) {
      return accounting.formatNumber(value / 100, 2, '.', ',')
    },
    newProduct () {
      this.invoice.products.push(Object.assign({id: Math.random()}, emptyProduct))
      setTimeout(() => {
        document.querySelector('#product-list tr:last-child input').focus()
      }, 0)
    },
    changeProduct (index, product) {
      this.invoice.products[index] = product
    },
    removeProduct (index) {
      this.invoice.products.splice(index, 1)
      if (!this.invoice.products.length) {
        this.newProduct()
      }
      setTimeout(() => {
        const el = document.querySelector(`#product-list tr:nth-child(${index + 1}) button`) ||
          document.querySelector('#product-list tr:last-child button')
        el.focus()
      }, 0)
    },
    removeFooter (index) {
      this.invoice.footer.splice(index, 1)
    },
    addFooter () {
      this.invoice.footer.push({
        id: Math.random(),
        name: '',
        value: ''
      })
      setTimeout(() => {
        document.querySelector('#foot tr:last-child input').focus()
      }, 0)
    }
  },
  components: {
    Editable,
    Products,
    ProductsSummary,
    ProductsTotal
  }
}
</script>

<style lang="scss" scoped>
@import "~assets/common.scss";

@media screen {
  div {
    box-sizing: border-box;
    box-shadow: 0 0 2em #999;
    padding: 2cm;
    background-color: #fff;
    width: 210mm;
    height: 297mm;
    margin: 2em auto 4em auto;
    cursor: default;
  }
}
@media print {
  #foot button {
    display: none !important;
  }
}
div {
  font-size: 10pt;
  font-family: "Helvetica", sans-serif;
}
#head {
  width: auto;
  margin-right: 0;
  margin-left: auto;
  border-collapse: collapse;
  line-height: 1.5em;

  td,th {
    position: relative;
    padding: 0;

    &:nth-child(2) {
      padding-right: 0.4em;
    }
  }
  th {
    font-weight: normal;
    text-align: right;
  }
}
#seller, #buyer {
  width: 48%;
  display: inline-block;
  vertical-align: top;
  margin-top: 2em;

  h3 {
    background-color: $tableBackground;
    border-bottom: 1px solid $tableBorder;
    padding: 0.4em;
    font-size: 10pt;
    margin: 0;
  }
  p {
    padding: 0.4em;
    margin: 0;
  }
}
#seller {
  margin-right: 3%;
}
h1 {
  text-align: center;
  font-weight: normal;
  font-size: 24pt;
  margin-bottom: 0;
  margin-top: 2em;
}
h2 {
  text-align: center;
  letter-spacing: 2px;
  margin-top: 0.5em;
}
table#products {
  width: 100%;
  border-collapse: collapse;

  td,th {
    padding: 0.4em;

    &.number {
      text-align: right;
    }
    &.empty {
      border-bottom: none;
    }
  }
  thead {
    background-color: $tableBackground;
    font-weight: bold;
    vertical-align: bottom;
    border-bottom: 1pt solid $tableBorder;
    span {
      display: inline-block;
      text-align: center;
    }
    .number span {
      width: auto;
      max-width: 4em;
    }
    small {
      display: block;
    }
  }
  tbody {
    td,th {
      border-bottom: 1px solid $tableBackground;
      position: relative;
    }
  }
  thead + tbody tr:last-child td {
    border-bottom: 1px solid $tableBorder;
  }
}
#foot {
  width: auto;
  border-collapse: collapse;
  line-height: 1.5em;

  .empty {
    td,th {
      &:nth-child(2):after {
        content: "";
      }
    }
  }
  td,th {
    position: relative;
    padding: 0;
    vertical-align: top;

    &:nth-child(2) {
      padding-right: 0.4em;

      &:after {
        content: ":";
      }
    }
  }
  th {
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
  }
  button {
    @extend %canBeActive;
    display: inline;
    margin: -2pt;
    padding: 2pt;
    position: absolute;
    border: none;
    outline-style: none;
    left: -4em;
    width: 4em;

    &:focus {
      @extend %active;
    }
  }
}
.signature {
  width: 29%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 4em;
  display: inline-block;
  text-align: center;

  p {
    min-height: 1em;
  }
  small {
    display: block;
    padding-top: 0.5em;
    border-top: 1px dotted black;
  }
}
</style>



/** WEBPACK FOOTER **
 ** Add.vue?14286003
 **/